import Service from '@/pages/dashboard/components/PageContainer/Service';
import { FilterContext } from '@/pages/dashboard/components/PageContainer/context';
import { formatFilterValues } from '@/pages/dashboard/utils/utils';
import React, { useContext, useMemo } from 'react';
import { shallowEqual, useSelector } from 'umi';

export default function ChurnAllUserService(props: any) {
  const { style, className, type, config, children, data: propsData, ...resetProps } = props || {};
  const { api, dataKey, refreshKey = '', interval } = config || {};
  const  { filterVal } = useContext(FilterContext);

  const { gameCode } = useSelector((state: any) => ({
    gameCode: state?.dashboard?.currentGame?.game_code,
  }), shallowEqual);

  const data = useMemo(() => ({
    gameCode,
    ...(propsData || {})
  }), [gameCode, propsData]);
  const timeTypeMap: any = {
    Week: 'weekly',
    Month: 'monthly',
    Day: 'daily'
  };

  return (
    <div className={className} style={style}>
      <Service
        api={api}
        data={data}
        dataKey={dataKey}
        refreshKey={refreshKey}
        interval={interval}
        beforeRequest={(data) => {
          const { filterVal, gameCode, byType, trackingFilter } = data;
          const { rangeTime, timeType, diff, timeDiff, ...filters } = filterVal || {};
          // 传参兜底筛选器参数
          let params: IApiParamsBase | IApiParamsWithKey = {
            game_code: gameCode,
            filters: formatFilterValues(filters),
            start_time: rangeTime[0],
            end_time: rangeTime[1],
          };

          if(dataKey === 'metrics'){
            params = {
              ...params,
              period: timeTypeMap[timeType]
            };
          }

          if(dataKey === 'countries_region_zone') {
            params = {
              ...params,
              by_type: 'country',
              period: timeTypeMap[timeType]
            };
          }

          if(dataKey === 'level_distribution'){
            params = {
              ...params,
              by_type: byType,
              date_type: timeTypeMap[timeType]
            };
          }

          if(dataKey === 'payer_churn'){
            params = {
              ...params,
              date_type: timeTypeMap[timeType]
            };
          }

          if(dataKey === 'first_day_distribution'){
            params = {
              ...params,
              period: 'daily'
            };
          }

          if(dataKey === 'linechart'){
            const trackFilter = Object.keys(trackingFilter).length === 0 ? {
              first_node: rangeTime[0],
              second_node: rangeTime[1],
              track_days: ['2']
            } : trackingFilter;

            params = {
              ...params,
              ...trackFilter
            };
          }

          return params;
        }}
        trackData={['gameCode', 'byType', 'trackingFilter']}
      >
        {
          React.Children.map(children, (child: any) => React.cloneElement(
            child,
            {
              filterVal,
              ...resetProps
            }
          ))
        }
      </Service>
    </div>
  );
};